/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

/**
 * File name validator utility
 * Ported from lego/page/browser/add-document/add-new-document/helpers/fileNameValidator.js
 *
 * Validates file names according to system rules:
 * - Cannot be '.' or '..'
 * - Cannot contain invalid characters: / \ : * ? " < > | and control characters
 * - Cannot start or end with whitespace
 * - Optionally restricts emojis
 */

export function isValid(value: string | null | undefined, isRestrictEmojis?: boolean): boolean {
  // Match common emoji ranges (ES5 compatible - split into separate tests)
  const emojiRanges = [
    /[\uD83D[\uDE00-\uDE4F]]/, // Emoticons
    /[\uD83C[\uDF00-\uDFFF]]/, // Misc Symbols and Pictographs
    /[\uD83D[\uDC00-\uDDFF]]/, // Misc Symbols and Pictographs
    /[\u2600-\u26FF]/, // Misc symbols
    /[\u2700-\u27BF]/ // Dingbats
  ]
  const regexForEmojis = new RegExp(emojiRanges.map((r) => r.source).join('|'))

  if (value) {
    // filename is . or .. (aka current/parent)
    if (value === '.' || value === '..') {
      return false
    } else if (
      value.indexOf('/') > -1 ||
      value.indexOf('\\') > -1 ||
      value.indexOf(':') > -1 ||
      value.indexOf('*') > -1 ||
      value.indexOf('?') > -1 ||
      value.indexOf('"') > -1 ||
      value.indexOf('<') > -1 ||
      value.indexOf('>') > -1 ||
      value.indexOf('|') > -1 ||
      value.indexOf('\t') > -1 ||
      value.indexOf('\r') > -1 ||
      value.indexOf('\n') > -1 ||
      value.indexOf('\f') > -1 ||
      value.indexOf('\b') > -1
    ) {
      return false
    }
    // first or last character is a space
    else if (/^\s+|\s+$/.test(value)) {
      return false
    } else if (isRestrictEmojis && regexForEmojis.test(value)) {
      return false
    }
  }
  return true
}
